export default "__VITE_ASSET__gZmoVJBT__"